npm <template>
  <v-app>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition" v-model="snackbar"
      timeout="2000" :value="true" color="warning" absolute outlined top right>
      <v-icon class="mr-2" color="warning">mdi-alert-outline</v-icon>
      {{ errMsg }}
      <v-icon @click="snackbar = false" class="float-right" color="warning">mdi-close-circle</v-icon>

    </v-snackbar>
    <v-container class="pa-0 pa-sm-3 pa-md-3">
      <div class="px-sm-4">
        <v-toolbar dense class="elevation-0 mb-4 mt-6 pr-4">
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold headline">Account opening</v-list-item-title>
                <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                  New openings of clients and process pending details here.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select v-if="modeis != 'r'" :disabled="clientLoader" color="#3B82F6" @change="clientFilter"
            style="max-width: 120px" outlined class="mr-4 mt-2 rounded-lg" dense :items="['All', 'RM', 'AP']"
            label="Clients" v-model="clientstype" hide-details></v-select>

          <v-autocomplete v-if="modeis != 'r' ? clientstype != 'All' : null" :disabled="clientLoader" color="#3B82F6"
            @change="clientDetails" style="max-width: 160px" outlined class="mr-4 mt-2 rounded-lg" dense
            :items="clisitems" label="AP/RM filter" v-model="clisimodel" hide-details></v-autocomplete>
          <v-text-field v-if="pnltab == 0" :disabled="clientLoader" color="#3B82F6"
            class="mr-4 mt-2 rounded-lg d-none d-md-flex" style="max-width: 160px" dense outlined flat label="Search"
            v-model="psearchText" prepend-inner-icon="mdi-magnify" hide-details>
          </v-text-field>
          <v-text-field v-else :disabled="processLoader" color="#3B82F6" class="mr-4 mt-2 rounded-lg d-none d-md-flex"
            style="max-width: 160px" dense outlined flat label="Search" v-model="searchText" hide-details
            prepend-inner-icon="mdi-magnify">
          </v-text-field>

          <v-tooltip open-delay="400" color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-card :disabled="clientLoader" v-bind="attrs" v-on="on"
                :color="`${tabval == 'currentmonth' ? '#EFF6FF' : ''}`" @click="tableFilter((val = 'currentmonth'))"
                width="40px" outlined class="mt-2 py-2 elevation-0 rounded-l-lg rounded-0 text-center">
                <span :style="`color:${tabval == 'currentmonth' ? '#3B82F6' : 'black'
                  };`" class="caption">CM</span>
              </v-card>
            </template>
            <span>Current month</span>
          </v-tooltip>

          <v-tooltip open-delay="400" color="black" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-card :disabled="clientLoader" v-bind="attrs" v-on="on"
                :color="`${tabval == 'lastmonth' ? '#EFF6FF' : ''}`" @click="tableFilter((val = 'lastmonth'))"
                width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
                <span :style="`color:${tabval == 'lastmonth' ? '#3B82F6' : 'black'
                  };`" class="caption">LM</span>
              </v-card>
            </template>
            <span>Last month</span>
          </v-tooltip>

          <v-card :disabled="clientLoader" :color="`${tabval == 'threemonth' ? '#EFF6FF' : ''}`"
            @click="tableFilter((val = 'threemonth'))" width="40px" outlined
            class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${tabval == 'threemonth' ? '#3B82F6' : 'black'};`" class="caption">3M</span>
          </v-card>
          <v-card :disabled="clientLoader" :color="`${tabval == 'sixmonth' ? '#EFF6FF' : ''}`"
            @click="tableFilter((val = 'sixmonth'))" width="40px" outlined
            class="mt-2 py-2 elevation-0 rounded-0 text-center">
            <span :style="`color:${tabval == 'sixmonth' ? '#3B82F6' : 'black'};`" class="caption">6M</span>
          </v-card>
          <v-card :disabled="clientLoader" :color="`${tabval == 'oneyear' ? '#EFF6FF' : ''}`"
            @click="tableFilter((val = 'oneyear'))" width="40px" outlined
            class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
            <span :style="`color:${tabval == 'oneyear' ? '#3B82F6' : 'black'};`" class="caption">1Y</span>
          </v-card>
        </v-toolbar>
        <div class="px-4 pt-6">
          <v-tabs v-model="pnltab" flat background-color="transparent" color="#3B82F6" active-class="font-weight-bold">
            <v-tab>
              <v-badge :value="clientpending.length" bordered color="#3B82F6" :content="clientpending.length">
                <span>Client Pending</span>
              </v-badge>
            </v-tab>
            <v-tab>
              <v-badge :value="processpending.length" bordered color="#3B82F6" :content="processpending.length">
                <span>Process Pending</span>
              </v-badge>
            </v-tab>
            <!-- <v-spacer></v-spacer> -->

          </v-tabs>
          <v-tabs-items v-model="pnltab">
            <v-tab-item>
              <div class="trdditl">
                <v-data-table :single-expand="csingleExpand" :expanded.sync="cexpanded" show-expand height="51vh" dense
                  fixed-header class="dataTable" style="border: 1px solid #efeef3" must-sort item-key="Serial_no"
                  :items-per-page="100" :footer-props="{
                    'items-per-page-options': [10, 30, 50, 100, -1],
                  }" :loading="clientLoader" :headers="headers" :items="clientpending" :search="psearchText"
                  :sort-by="['starttime']" :sort-desc="[true]">
                  <template v-slot:[`item.pan`]="{ item }">
                    <span>{{ item.pan }}
                      <v-chip v-if="clientstype == 'All'" x-small color="#EFF6FF" text-color="#3B82F6">
                        {{ item.rmcode }}
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
                    <td class="text-start">
                      <v-btn icon @click="expand(!isExpanded), ageingCalc(item, m = 'c')"
                        class="v-data-table__expand-icon" :class="{ 'v-data-table__expand-icon--active': isExpanded }">
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td class="pa-0" :colspan="headers.length">
                      <v-card class="elevation-0 rounded-0" width="100%">
                        <v-stepper v-if="item.name.counts >= 0" class="steps elevation-0">
                          <v-stepper-header>
                            <v-stepper-step :complete="item.name.counts >= 1"
                              :complete-icon="item.name.counts >= 1 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="1" :color="item.name.counts >= 1 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Email</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.application_email ?
                                item.name.application_email : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 2"
                              :complete-icon="item.name.counts >= 2 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="2" :color="item.name.counts >= 2 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Pan</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.email_pan ?
                                item.name.email_pan : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 3"
                              :complete-icon="item.name.counts >= 3 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="3" :color="item.name.counts >= 3 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Digilocker</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.pan_digilocker ?
                                item.name.pan_digilocker : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 4"
                              :complete-icon="item.name.counts >= 4 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="4" :color="item.name.counts >= 4 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Peenydrop</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.digilocker_peenydrop ?
                                item.name.digilocker_peenydrop : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 5"
                              :complete-icon="item.name.counts >= 5 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="5" :color="item.name.counts >= 5 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Document</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.pennydrop_document ?
                                item.name.pennydrop_document : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 6"
                              :complete-icon="item.name.counts >= 6 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="6" :color="item.name.counts >= 6 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Verification</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.document_emailbeforesignin ? item.name.document_emailbeforesignin : 'Pending.'
                              }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 7"
                              :complete-icon="item.name.counts >= 7 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="7" :color="item.name.counts >= 7 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">e-sign</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.emailbeforesignin_equityesighned ? item.name.emailbeforesignin_equityesighned :
                                'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>

                            <!-- <v-stepper-step complete step="8" :color="item.name.counts == 1 ? '#FFC107' : item.name.counts >= 1 ? '#3B82F6' :'#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">KRA esign</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.equityesighned_kraesighned ? item.name.equityesighned_kraesighned : 'Pending.'
                              }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider> -->

                            <!-- <v-stepper-step complete step="9" :color="item.name.counts == 1 ? '#FFC107' : item.name.counts >= 1 ? '#3B82F6' :'#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Email aft signin</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.kraesighned_emailaftersignin ? item.name.kraesighned_emailaftersignin :
                                'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider> -->


                          </v-stepper-header>
                        </v-stepper>
                        <div class="text-center py-6" v-else-if="item.name == 'no'">
                          <p class="caption mb-0">no data found</p>
                        </div>
                        <v-progress-linear v-else indeterminate color="#3B82F6"></v-progress-linear>
                      </v-card>
                    </td>
                  </template>
                  <template v-slot:[`item.email`]="{ item }">
                    <span class="mb-0">{{ item.email }}
                      <br>
                    </span>
                    <span style="font-size: 10px;"><b>{{ item.nameis }}</b></span>
                  </template>

                </v-data-table>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="trdditl">
                <v-data-table :single-expand="psingleExpand" :expanded.sync="pexpanded" show-expand height="51vh" dense
                  fixed-header class="dataTable" style="border: 1px solid #efeef3" must-sort item-key="Serial_no"
                  :items-per-page="100" :footer-props="{
                    'items-per-page-options': [10, 30, 50, 100, -1],
                  }" :loading="processLoader" :headers="headers" :items="processpending" :search="searchText"
                  :sort-by="['starttime']" :sort-desc="[true]">
                  <!-- <template v-slot:[`item.days_difference`]="{ item }">
                    {{ item.days_difference > 0 ? `${item.days_difference} days ago` : '-' }}
                  </template> -->
                  <template v-slot:[`item.pan`]="{ item }">
                    <span>{{ item.pan }}
                      <v-chip v-if="clientstype == 'All'" x-small color="#EFF6FF" text-color="#3B82F6">
                        {{ item.rmcode }}
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
                    <td class="text-start">
                      <v-btn icon @click="expand(!isExpanded), ageingCalc(item, m = 'p')"
                        class="v-data-table__expand-icon" :class="{ 'v-data-table__expand-icon--active': isExpanded }">
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </td>
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td class="pa-0" :colspan="headers.length">
                      <v-card class="elevation-0 rounded-0" width="100%">
                        <v-stepper v-if="item.name.counts >= 0" class="steps elevation-0">
                          <v-stepper-header>
                            <v-stepper-step :complete="item.name.counts >= 1"
                              :complete-icon="item.name.counts >= 1 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="1" :color="item.name.counts >= 1 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Email</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.application_email ?
                                item.name.application_email : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 2"
                              :complete-icon="item.name.counts >= 2 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="2" :color="item.name.counts >= 2 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Pan</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.email_pan ?
                                item.name.email_pan : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 3"
                              :complete-icon="item.name.counts >= 3 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="3" :color="item.name.counts >= 3 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Digilocker</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.pan_digilocker ?
                                item.name.pan_digilocker : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 4"
                              :complete-icon="item.name.counts >= 4 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="4" :color="item.name.counts >= 4 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Peenydrop</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.digilocker_peenydrop ?
                                item.name.digilocker_peenydrop : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 5"
                              :complete-icon="item.name.counts >= 5 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="5" :color="item.name.counts >= 5 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Document</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{ item.name.pennydrop_document ?
                                item.name.pennydrop_document : 'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 6"
                              :complete-icon="item.name.counts >= 6 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="6" :color="item.name.counts >= 6 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Verification</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.document_emailbeforesignin ? item.name.document_emailbeforesignin : 'Pending.'
                              }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider>

                            <v-stepper-step :complete="item.name.counts >= 7"
                              :complete-icon="item.name.counts >= 7 ? 'mdi-checkbox-marked-circle-outline' : 'mdi-timer-sand'"
                              step="7" :color="item.name.counts >= 7 ? '#3B82F6' : '#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">e-sign</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.emailbeforesignin_equityesighned ? item.name.emailbeforesignin_equityesighned :
                                'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>

                            <!-- <v-stepper-step complete step="8" :color="item.name.counts == 1 ? '#FFC107' : item.name.counts >= 1 ? '#3B82F6' :'#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">KRA esign</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.equityesighned_kraesighned ? item.name.equityesighned_kraesighned : 'Pending.'
                              }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider> -->

                            <!-- <v-stepper-step complete step="9" :color="item.name.counts == 1 ? '#FFC107' : item.name.counts >= 1 ? '#3B82F6' :'#FFC107'">
                              <v-list-item-title class="fs-12 font-weight-bold">Email aft signin</v-list-item-title>
                              <v-list-item-subtitle class="fs-10 font-weight-light">{{
                                item.name.kraesighned_emailaftersignin ? item.name.kraesighned_emailaftersignin :
                                'Pending.' }}</v-list-item-subtitle>
                            </v-stepper-step>
                            <v-divider></v-divider> -->


                          </v-stepper-header>
                        </v-stepper>
                        <div class="text-center py-6" v-else-if="item.name == 'no'">
                          <p class="caption mb-0">no data found</p>
                        </div>
                        <v-progress-linear v-else indeterminate color="#3B82F6"></v-progress-linear>
                      </v-card>
                    </td>
                  </template>

                  <template v-slot:[`item.email`]="{ item }">
                    <span class="mb-0">{{ item.email }}
                      <br>
                    </span>
                    <span style="font-size: 10px;"><b>{{ item.nameis }}</b></span>
                  </template>

                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </v-container>
  </v-app>
</template>
    
<script>
import { apiurl, ageingurl, ageingurlo } from "../apiUrl";
import axios from "axios";

export default {
  data() {
    return {
      pexpanded: [],
      psingleExpand: true,

      cexpanded: [],
      csingleExpand: true,

      snackbar: false,
      clientData: [],
      topPerfom: [],
      worstPerfom: [],
      topPerfomClient: [],
      worstPerfomClient: [],
      topPerfomClientid: "",
      worstPerfomClientid: "",
      overalTotalClient: "",
      overalTotal: [],
      errMsg: "",

      clientidsindex: "",
      pnltab: null,
      usertotaldata: true,
      usernodata: false,

      clientids: ["All"],
      emailDatafetch: [],

      newPnL: [],
      PnLSummary: [],
      PnLdaywise: [],
      tol_DW_mtm: 0,
      tol_Summ_mtm: 0,
      total_day_wise: 0,
      total_summary: 0,
      DW_qty: 0,
      Summ_qty: 0,
      // clientData:[]

      clientLoaderclient: false,
      clientLoader: true,
      processLoader: true,
      processpending: [],
      clientpending: [],

      clientDataRaw: [],
      Analysis_data: [],
      Analysis_dataState: [],
      Analysis_dataGender: [],
      Analysis_dataQual: [],
      Analysis_dataOccu: [],
      Analysis_dataCity: [],
      Analysis_dataAge: [],
      Analysis_dataStatus: [],
      compKey: [],
      compVey: [],
      lastTrade: [],

      datesummary: [],
      startDate: "",
      endDates: "",
      monthname: [],
      coractdata: true,
      nocoractdata: false,
      coractloader: false,
      values: [],
      dateselect: "",

      psearchText: "",
      searchText: "",
      clientWiseData: [],

      tabval: "currentmonth",

      clisitems: [],
      clisimodel: null,
      clientstype: 'All',
      modeis: null
    };
  },

  created() {

  },

  mounted() {
    let branchcode = localStorage.getItem('brcode')
    if (branchcode != null && branchcode) {
      let modeis = localStorage.getItem('mode');
      if (modeis == 'RM') {
        this.modeis = 'r';
        this.clientstype = 'RM';
        this.clientDetails();
      } else {
        this.modeis = 'b';
        this.clientstype = 'All';
        this.clientFilter();
      }
    } else {
      this.$router.push("/");
    }
  },

  methods: {
    clientFilter() {
      if (this.clientstype != 'All') {
        this.clisitems = [];
        this.clientLoader = true;
        this.processLoader = true;
        this.clientpending = [];
        this.processpending = [];
        let branchcode = localStorage.getItem('brcode')
        let url = this.clientstype == 'AP' ? `${apiurl}/remshire_list` : `${apiurl}/employee_list`
        let data = JSON.stringify({
          "branch_code": branchcode
        });

        let config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data: data
        };

        let axiosThis = this;
        axios.request(config)
          .then((response) => {
            // console.log(JSON.stringify(response.data));
            if (response.data.length > 0) {
              axiosThis.clisitems = response.data;
              axiosThis.clisitems.sort();
              axiosThis.clisimodel = axiosThis.clisitems[0];
              axiosThis.clientDetails();
            } else {
              axiosThis.clientpending = [];
              axiosThis.processpending = [];
              axiosThis.errMsg = "Data Not Found";
              axiosThis.snackbar = true;
              axiosThis.clientLoader = false;
              axiosThis.processLoader = false;
            }
          })
          .catch((error) => {
            console.log(error);
            axiosThis.clientLoader = false;
            axiosThis.processLoader = false;
          });
      } else {
        this.allclientDetails();
      }
    },

    tableFilter(val) {
      if (val != this.tabval) {
        this.tabval = val;
        let modeis = localStorage.getItem('mode');
        if (modeis == 'RM') {
          this.modeis = 'r';
          this.clientstype = 'RM';
          this.clientDetails();
        } else {
          this.modeis = 'b';
          this.clientstype = this.clientstype ? this.clientstype : 'All';
          this.clientFilter();
        }
      }
    },
    allclientDetails() {
      this.clientLoader = true;
      this.processLoader = true;

      this.clientpending = [];
      this.processpending = [];

      var axiosThis = this;
      let branchcode = localStorage.getItem('brcode')

      var data = JSON.stringify({
        branch_code: branchcode,
        status: "processpending",
        values: this.tabval,
      });
      var config = {
        method: "post",
        url: `${apiurl}/ekyc`,

        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.length > 0) {
            let data = response.data;
            for (let c = 0; c < data.length; c++) {
              data[c].rmcode = data[c].rmcode.split("/")[0];
              data[c]['nameis'] = data[c].name != null ? data[c].name : '-'
              data[c].name = data[c].name != null ? data[c].name : '-';
            }
            axiosThis.processpending = data;
          } else {
            axiosThis.processpending = [];
            axiosThis.errMsg = "Process Pending, Data Not Found";
            axiosThis.snackbar = true;
          }
          axiosThis.processLoader = false;

        })
        .catch(function (error) {
          console.log(error);
          axiosThis.processLoader = false;
        });

      var pdata = JSON.stringify({
        branch_code: branchcode,
        status: "clientpending",
        values: this.tabval,
      });
      var pconfig = {
        method: "post",
        url: `${apiurl}/ekyc`,

        headers: {
          "Content-Type": "application/json",
        },
        data: pdata,
      };

      axios(pconfig)
        .then(function (response) {
          if (response.data.length > 0) {
            let data = response.data;
            for (let c = 0; c < data.length; c++) {
              data[c].rmcode = data[c].rmcode.split("/")[0];
              data[c]['nameis'] = data[c].name != null ? data[c].name : '-'
              data[c].name = data[c].name != null ? data[c].name : '-';
            }
            axiosThis.clientpending = data;
          } else {
            axiosThis.clientpending = [];
            axiosThis.errMsg = "Client Pending, Data Not Found";
            axiosThis.snackbar = true;
          }
          axiosThis.clientLoader = false;
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.clientLoader = false;
        });

    },
    clientDetails() {
      this.clientLoader = true;
      this.processLoader = true;

      this.clientpending = [];
      this.processpending = [];

      var axiosThis = this;
      // this.branchcode = localStorage.getItem('brcode')
      let branchcode = localStorage.getItem('brcode')
      var clientCode = this.modeis == 'r' ? branchcode : this.clisimodel;
      // var usession = localStorage.getItem("session");
      var data = JSON.stringify({
        code: clientCode,
        status: "processpending",
        values: this.tabval,
      });
      var config = {
        method: "post",
        url: `${apiurl}/ekyc1`,

        headers: {
          "Content-Type": "application/json",
          // Authorization: usession,
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.length > 0) {
            let responseis = response.data;
            for (let e = 0; e < responseis.length; e++) {
              responseis[e]['nameis'] = responseis[e].name != null ? responseis[e].name : '-'
              responseis[e].name = responseis[e].name != null ? responseis[e].name : '-'
            }
            axiosThis.processpending = responseis;

          } else {
            axiosThis.processpending = [];
            axiosThis.errMsg = "Process Pending, Data Not Found";
            axiosThis.snackbar = true;
          }
          axiosThis.processLoader = false;

        })
        .catch(function (error) {
          console.log(error);
          axiosThis.processLoader = false;
        });

      var pdata = JSON.stringify({
        code: clientCode,
        status: "clientpending",
        values: this.tabval,
      });
      var pconfig = {
        method: "post",
        url: `${apiurl}/ekyc1`,

        headers: {
          "Content-Type": "application/json",
          // Authorization: usession,
        },
        data: pdata,
      };

      axios(pconfig)
        .then(function (response) {
          if (response.data.length > 0) {
            let responseis = response.data;
            for (let e = 0; e < responseis.length; e++) {
              responseis[e]['nameis'] = responseis[e].name != null ? responseis[e].name : '-'
              responseis[e].name = responseis[e].name != null ? responseis[e].name : '-'
            }
            axiosThis.clientpending = responseis;
          } else {
            axiosThis.clientpending = [];
            axiosThis.errMsg = "Client Pending, Data Not Found";
            axiosThis.snackbar = true;
          }
          axiosThis.clientLoader = false;
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.clientLoader = false;
        });

      // console.log("clientDataRaw", axiosThis.clientDataRaw);
    },
    ageingCalc(item, m) {
      let itemsdata = m == 'p' ? this.processpending : this.clientpending;
      let editedIndex = itemsdata.indexOf(item)
      // console.log(item, editedIndex)
      let data = JSON.stringify({
        "mobile": item.mobile
      });

      let config = {
        method: 'post',
        url:item.type == "new_ekyc" ?  ageingurlo : ageingurl,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          if (response.data[0]) {
            if (m == 'p') {
              axiosThis.processpending[editedIndex].name = response.data[0]
            } else {
              axiosThis.clientpending[editedIndex].name = response.data[0]
            }
            // console.log(axiosThis.processpending, axiosThis.clientpending);
          } else {
            if (m == 'p') {
              axiosThis.processpending[editedIndex].name = "no"
            } else {
              axiosThis.clientpending[editedIndex].name = "no"
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  computed: {
    headers() {
      return [
        { text: "Created", value: "starttime" },
        { text: "Mobile", value: "mobile", sortable: false },
        // { text: "Name", value: "name", sortable: false, width: '4%' },
        { text: "Email", value: "email", sortable: false },
        { text: "PAN", value: "pan", sortable: false },
        { text: "Status", value: "activestatus", sortable: false },
        { text: "Last Update", value: "days_difference", sortable: false },
      ];
    },
  },
};
</script>
    
<style>
.inlinebb {
  display: inline-flex;
}

.colums {
  position: static;
  float: left;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.dataTable {
  overflow-y: scroll;
}

.dataTable thead.v-data-table-header {
  position: relative;
  z-index: 1 !important;
}

/* .headline { */
/* font-family: 'DM Sans' !important; */
/* font-weight: 500; */
/* } */
.trdditl::-webkit-scrollbar {
  width: 6px;
}

.trdditl::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.trdditl::-webkit-scrollbar-thumb {
  background: rgba(128, 128, 128, 0.6);
  border-radius: 16px;
}

.toolbar .v-toolbar__content {
  padding: 0 !important;
}

.datedetailshead .v-data-table-header__sort-badge {
  display: none !important;
}

.steps .v-stepper__step {
  padding: 8px 12px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-10 {
  font-size: 10px !important;
}

.steps .v-application--is-ltr .v-stepper__step__step {
  margin-right: 3px !important;
}
</style>
<style lang="scss">
.colums {
  position: static;
  float: left;
}
</style>
    